/**
 * GridConstants
 *
 * Base constants for the grid system to avoid circular dependencies.
 * This file should have NO internal project dependencies.
 */

export const GRID_CONSTANTS = {
  TILE_SIZE: 32,
  DEFAULT_WIDTH: 100,
  DEFAULT_HEIGHT: 50,
  DEFAULT_GRAVITY: 1500,
  DEFAULT_BG_COLOR: '#87CEEB',
  DEFAULT_VERSION: '1.0',
};

export const LEVEL_STORAGE_CONSTANTS = {
  STORAGE_PREFIX: 'helix_level_',
  LEVEL_INDEX_KEY: 'helix_levels_index',
};

export const EDITOR_CAMERA_CONSTANTS = {
  MIN_ZOOM: 0.2,
  MAX_ZOOM: 3.0,
  ZOOM_SPEED: 0.1,
  PAN_SPEED: 0.5, // Pixels per ms
  SHAPE_DRAG_THRESHOLD: 5, // Pixels before drag is considered movement
};

export const CAMERA_DEFAULTS = {
  ZOOM: 1.0,
  MIN_ZOOM: 0.25,
  MAX_ZOOM: 4.0,
  FOLLOW_SPEED: 0.05,
  LOOKAHEAD_X: 50,
  LOOKAHEAD_Y: 20,
  SMOOTHING: 0.1,
  OFFSET_X: 0,
  OFFSET_Y: -50,
  DEADZONE_WIDTH: 100,
  DEADZONE_HEIGHT: 50,
  IDLE_LOCK_ENABLED: true,
  IDLE_LOCK_THRESHOLD: 10,
  IDLE_LOCK_SMOOTHING: 0.02,
  IDLE_DEADZONE_X: 150,
  IDLE_DEADZONE_Y: 100,
  MAX_VEL_X: 500,
  MAX_VEL_Y: 600,
};
